import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router";
import SettingsBar from "../settingsBar/SettingsBar";
import { useSettingsLayoutStyles } from "./SettingsLayout.styles";

const hiddenSettingsBarPaths = ["/privacy/settings/entity-templates/"];

function SettingsLayout() {
    const styles = useSettingsLayoutStyles();
    const location = useLocation();
    const hideSettingsBar = hiddenSettingsBarPaths.some((path) => location.pathname.startsWith(path));

    return (
        <Box sx={styles.container}>
            {!hideSettingsBar && <SettingsBar />}
            <Box sx={[styles.content, hideSettingsBar && { overflow: "visible" }]}>
                <Outlet />
            </Box>
        </Box>
    );
}

export default SettingsLayout;
